import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, ArrowRight } from "lucide-react";
import { MaskedLines, Reveal } from "@/components/motion/primitives";

export const Spinner = () => (
  <div className="flex items-center justify-center py-32" data-testid="loading-spinner">
    <div className="w-8 h-8 border-2 border-border border-t-primary rounded-full animate-spin" />
  </div>
);

export const PrimaryButton = ({ children, className = "", ...props }) => (
  <button
    className={`inline-flex items-center gap-2 bg-primary text-white px-7 py-4 font-semibold hover:bg-primary/90 transition-colors active:scale-95 ${className}`}
    {...props}
  >
    {children}
  </button>
);

export const OutlineButton = ({ children, className = "", ...props }) => (
  <button
    className={`inline-flex items-center gap-2 border border-border px-7 py-4 font-semibold hover:border-primary hover:text-primary transition-colors active:scale-95 ${className}`}
    {...props}
  >
    {children}
  </button>
);

export const LinkButton = ({ to, children, primary, className = "" }) => (
  <Link
    to={to}
    className={`inline-flex items-center gap-2 px-7 py-4 font-semibold transition-colors active:scale-95 ${
      primary ? "bg-primary text-white hover:bg-primary/90" : "border border-border hover:border-primary hover:text-primary"
    } ${className}`}
  >
    {children}
  </Link>
);

// Page hero used across inner pages
export const PageHeader = ({ chapter, titleLines, description, action }) => (
  <section className="pt-36 md:pt-44 pb-16 md:pb-24 border-b border-border">
    <div className="mx-auto max-w-[1600px] px-5 md:px-10">
      {chapter && <p className="overline text-primary mb-6" data-testid="page-chapter">{chapter}</p>}
      <MaskedLines
        lines={titleLines}
        className="font-display text-5xl md:text-7xl lg:text-8xl leading-[0.92] max-w-5xl"
        data-testid="page-title"
      />
      {description && (
        <Reveal delay={0.3}>
          <p className="mt-8 text-lg md:text-xl text-muted-foreground max-w-2xl leading-relaxed">{description}</p>
        </Reveal>
      )}
      {action && <Reveal delay={0.4}><div className="mt-10">{action}</div></Reveal>}
    </div>
  </section>
);

export const SectionTitle = ({ overline, title, className = "" }) => (
  <div className={`mb-12 ${className}`}>
    {overline && <p className="overline text-primary mb-4">{overline}</p>}
    <h2 className="font-display text-4xl md:text-6xl leading-[0.95]">{title}</h2>
  </div>
);

export const Tag = ({ children, active, onClick }) => (
  <button
    onClick={onClick}
    className={`px-4 py-2 text-sm font-mono uppercase tracking-wider border transition-colors ${
      active ? "bg-primary text-white border-primary" : "border-border hover:border-primary text-foreground/80"
    }`}
  >
    {children}
  </button>
);

export { ArrowUpRight, ArrowRight };
